import {makeMachine} from "./states";
import {makeActions} from "./actions";
import {makeGetters} from "./getters";
import {makeGuards} from "./guards";
import {makeServices} from "./services";

const makeOptions = dependencies => {
    return {
        actions: makeActions(dependencies),
        getters: makeGetters(dependencies),
        guards: makeGuards(dependencies),
        services: makeServices(dependencies),
    };
};

export {makeMachine, makeOptions};
